import { useAuth } from "@/context/AuthContext";
import { Link, useLocation } from "react-router-dom";
import { Film, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Navbar() {
  const { user, logout } = useAuth();
  const location = useLocation();

  return (
    <header className="sticky top-0 z-40 glass border-b border-white/5">
      <div className="max-w-[1600px] mx-auto flex items-center justify-between px-6 lg:px-10 h-16">
        <Link to="/" className="flex items-center gap-3 group" data-testid="brand-link">
          <div className="w-9 h-9 border border-primary/60 flex items-center justify-center transition-colors group-hover:bg-primary/10">
            <Film className="w-4 h-4 text-primary" />
          </div>
          <div className="leading-tight">
            <div className="text-[10px] tracking-[0.3em] text-primary font-mono">
              ANUTRACKS12
            </div>
            <div className="font-semibold tracking-tight">Subtitle Studio</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1 text-sm">
          <Link
            to="/"
            data-testid="nav-studio"
            className={`px-4 py-2 transition-colors ${
              location.pathname === "/" ? "text-primary" : "text-muted-foreground hover:text-foreground"
            }`}
          >
            Studio
          </Link>
          <Link
            to="/history"
            data-testid="nav-history"
            className={`px-4 py-2 transition-colors ${
              location.pathname.startsWith("/history") ? "text-primary" : "text-muted-foreground hover:text-foreground"
            }`}
          >
            History
          </Link>
        </nav>

        <div className="flex items-center gap-3">
          {user && (
            <div className="hidden sm:flex flex-col items-end">
              <div className="text-[10px] font-mono tracking-widest text-muted-foreground">
                SIGNED IN
              </div>
              <div className="text-sm font-medium">{user.username}</div>
            </div>
          )}
          <Button
            variant="ghost"
            size="sm"
            onClick={logout}
            data-testid="logout-button"
            className="rounded-none border border-white/10 hover:bg-secondary/60"
          >
            <LogOut className="w-4 h-4 sm:mr-2" />
            <span className="hidden sm:inline">Sign out</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
